<template>
    <div class="z-50 fixed w-full h-full top-0 left-0 flex items-center">
        <div class="absolute w-full h-full bg-gray-900 opacity-50" @click.self="close"></div>
        <div class="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50">
            <div>
                <p class="text-md text-center py-4 bg-gray-500 text-white font-bold w-full border-b shadow" :class="headerBg">
                    <slot name="header"></slot>
                </p>

                <div class="mx-4 my-4 flex flex-col">
                    <!-- Body -->
                    <slot name="body"></slot>

                    <!--Footer-->
                    <slot name="footer"></slot>
                </div>

                <!--Footer-->
                <slot name="footer-without-padding"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalBase",
        props: ['modalType'],
        computed: {
          headerBg() {
              let className = 'bg-red-600';

              if (this.modalType === 'initial') {
                  className = 'bg-gray-600';
              } else if (this.modalType === 'error') {
                  className = 'bg-red-600'
              } else if (this.modalType === 'success') {
                  className = 'bg-green-600'
              } else if (this.modalType === 'invitationAlreayUsed') {
                  className = 'bg-gray-600';
              } else if (this.modalType === 'invitationNotExisting') {
                  className = 'bg-gray-600';
              } else if (this.modalType === 'info') {
                  className = 'bg-blue-500';
              }

              return className;
          }
        },
        methods: {
            submit() {
                this.$emit('submit');
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>

</style>